/**
 * La unidad en la que el panel muestra el consumo.
 *
 * ── Por qué no se llaman «neuronas» ─────────────────────────────────────────────
 * «Neurona» es el nombre que le pone Cloudflare a su unidad de facturación, y era exacto
 * mientras Workers AI era el único proveedor. Ya no lo es: los modelos de Google se cobran
 * por imagen en dólares y se convierten a esta misma unidad para que **un solo tope cubra a
 * los dos**.
 *
 * Seguir llamándolas neuronas hacía creer dos cosas falsas: que el cobro sale de Cloudflare, y
 * que el número significa algo en el panel de ellos. No significa nada ahí.
 *
 * ── Por qué el código sigue diciendo `neurons` ──────────────────────────────────
 * En el servidor y en la base sí son neuronas cuando el proveedor es Workers AI: es la unidad
 * real que factura Cloudflare, y renombrarla ahí perdería la correspondencia con su panel
 * justo donde hace falta para auditar una diferencia.
 *
 * La traducción vive acá, en la capa que se lee. Es la única frontera donde el nombre cambia.
 */

/** Precio de mil créditos, que es la tarifa de Workers AI por encima del tramo gratuito. */
export const USD_PER_1K_CREDITS = 0.011;

export const CREDITS_LABEL = 'créditos';

export function formatCredits(value: number): string {
  return Math.round(value).toLocaleString('es-AR');
}

/** Lo que costaría ese consumo en dinero, si excediera lo gratuito del día. */
export function creditsToUsd(credits: number): number {
  return (credits / 1000) * USD_PER_1K_CREDITS;
}

export function formatUsd(value: number): string {
  return `USD ${value.toFixed(2)}`;
}
